import { put, fork, call, takeLatest, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadShareCodeInfoCompletion,
  loadInfoByShareCodeCompletion,
  updateShareCodeCompletion,
  loadInfoByPhoneNumberCompletion,
  editManagerPhoneCompletion,
  catchError,
} from '../../actions';

export function* watchLoadInfo() {
  yield takeLatest('LOAD_SHARE_CODE_INFO', function*() {
    const options = {
      url: '/api/user/myInvite',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadShareCodeInfoCompletion(result.error, result.data));
  });
}

export function* watchLoadUser() {
  yield takeLatest('LOAD_INFO_BY_SHARE_CODE', function*({ code }) {
    const options = {
      url: `/api/user/getByInviteCode/${code}`,
      error_silent: true,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadInfoByShareCodeCompletion(result.error, result.data));
  });
}

export function* watchEdit() {
  yield takeLatest('UPDATE_SHARE_CODE', function*({ code }) {
    let error;

    if (!code) {
      error = new Error('请输入邀请码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(updateShareCodeCompletion(error));
      return;
    }

    const options = {
      url: `/api/user/useInviteCode/${code}`,
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(updateShareCodeCompletion(result.error, result.data));
  });
}

export function* watchLoadUserByPhone() {
  yield takeLatest('LOAD_INFO_BY_PHONE_NUMBER', function*({ phone }) {
    const options = {
      url: '/api/user/manager/findByMobile',
      data: {
        mobile: phone,
      },
      error_silent: true,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadInfoByPhoneNumberCompletion(result.error, result.data));
  });
}

export function* watchEditPhone() {
  yield takeLatest('EDIT_MANAGER_PHONE', function*({ phone }) {
    let error;

    if (!phone) {
      error = new Error('请输入手机号码');
    }

    if (error) {
      yield put(catchError(error));
      yield put(editManagerPhoneCompletion(error));
      return;
    }

    const options = {
      url: '/api/user/manager/changeManager',
      data: {
        managerMobile: phone,
      },
      method: 'POST',
    };
    const result = yield call(app.httpFetch, options);
    yield put(editManagerPhoneCompletion(result.error, result.data));
  });
}

export default function* codeSaga() {
  yield all([
    fork(watchLoadInfo),
    fork(watchLoadUser),
    fork(watchEdit),
    fork(watchLoadUserByPhone),
    fork(watchEditPhone),
  ]);
}
